import React from "react";
import { Box } from "@mui/material";
import Input from "models/input/input";
import { FacetFields } from "models/facet-fields";
import Breadcrumb from "components/sitelet/navigation/breadcrumb";
import SearchBar from "components/sitelet/navigation/search-bar";

const BaseHeader = ({
  showBreadcrumb,
  input,
  searchParams,
  facets,
}: {
  showBreadcrumb: boolean;
  input?: Input | null;
  searchParams: URLSearchParams;
  facets: FacetFields;
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
        maxWidth: "95vw",
      }}
    >
      {showBreadcrumb && (
        <Breadcrumb
          domain={input?.domain ? input.domain : searchParams.get("Domains")}
          datatype={
            input?.datatype ? input.datatype : searchParams.get("Datatypes")
          }
          group={
            input?.owner_group ? input.owner_group : searchParams.get("Groups")
          }
          input={input?.input_id}
        />
      )}
      {!(
        ["nrdata-orig"].includes(process.env.REACT_APP_STYLING_THEME ?? "") &&
        input
      ) && (
        <Box display="flex" flexDirection="column" sx={{ width: "100%" }} p={2}>
          <SearchBar facets={facets} />
        </Box>
      )}
    </Box>
  );
};

export default BaseHeader;
